module.exports = __webpack_public_path__ + "img/03.c15f9e06.png";